import { render, staticRenderFns } from "./KNavbarLink.vue?vue&type=template&id=70733b3a&scoped=true&"
import script from "./KNavbarLink.vue?vue&type=script&lang=js&"
export * from "./KNavbarLink.vue?vue&type=script&lang=js&"
import style0 from "./KNavbarLink.vue?vue&type=style&index=0&id=70733b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70733b3a",
  null
  
)

component.options.__file = "KNavbarLink.vue"
export default component.exports